import List from './List';
import Show from './Show';

export default {
  name: 'engagementCases',
  list: List,
  show: Show,
  options: {
    group: 'Integrations',
    label: 'Engagement Cases',
  },
};
